import * as React from "react";
import { BrComponent } from "@bloomreach/react-sdk";
const CmsComponentSlot = ({
  path = "main",
  children
}) => {
  return /* @__PURE__ */ React.createElement(BrComponent, { path, children });
};
export {
  CmsComponentSlot,
  CmsComponentSlot as default
};
//# sourceMappingURL=Slot.js.map
